import React, { useEffect, useState } from 'react';
import { AlertCircleIcon, ClockIcon } from 'lucide-react';
const START_SECONDS = 8 * 60 + 45;
function format(total: number) {
  const m = Math.floor(total / 60).toString().padStart(2, '0');
  const s = (total % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
}
export function AnnouncementBar() {
  const [secondsLeft, setSecondsLeft] = useState(START_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  return <div className="sticky top-0 z-50 w-full border-b border-orange-500/30 bg-zinc-950/95 backdrop-blur" data-id="element-15">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-center gap-1.5 px-4 py-2 text-center sm:flex-row sm:gap-3" data-id="element-16">
        <span className="flex items-center gap-2 text-xs font-semibold text-zinc-100 sm:text-sm" data-id="element-17">
          <AlertCircleIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-18" />
          <span data-id="element-19">
            <span className="font-bold text-red-400" data-id="element-20">ATENCIÓN:</span> Solo por
            hoy, obtén la Licencia de Reventa del 50%{' '}
            <span className="font-bold text-amber-400" data-id="element-21">GRATIS</span> con tu
            acceso.
          </span>
        </span>
        <span className="flex items-center gap-1.5 rounded-full bg-red-500/15 px-2.5 py-1 text-xs font-bold text-red-300 sm:text-sm" data-id="element-22">
          <ClockIcon className="h-4 w-4 shrink-0 animate-pulseGlow text-red-400" aria-hidden="true" data-id="element-23" />
          <span data-id="element-24">Quedan:</span>
          <span className="tabular-nums tracking-wider text-red-200" aria-live="polite" data-id="element-25">
            {format(secondsLeft)}
          </span>
        </span>
      </div>
    </div>;
}